/* Email popup trigger/suppression/success driver. Ported from the proven
   Lakeday welcome-popup logic (live-verified 7-14) with the storage key
   rescoped to this store. Loaded from the layout with defer — inline section
   scripts are unreliable in Horizon.

   Behaviour: after `delay` seconds it arms; it then opens on scroll past the
   per-device threshold, or on desktop exit intent. Closing (any way) writes
   the storage key and it never opens again in that browser. A successful
   subscribe re-renders the section in its success state, which opens once
   immediately to show the code, and the close writes the same key.

   Teaser tab (2026-09-24): once the popup has been closed without a
   subscribe, #d2-teaser stays in the corner on every later view and reopens
   the same dialog. Its own ✕, or a subscribe, retires it (TEASER_KEY). */
(() => {
  const dialog = document.getElementById('d2-popup');
  if (!dialog || dialog.dataset.bound === 'true') return;
  dialog.dataset.bound = 'true';

  const KEY = 'd2-popup-v1';
  const markDone = () => {
    try {
      localStorage.setItem(KEY, '1');
    } catch (e) {}
  };
  const alreadySeen = () => {
    try {
      return localStorage.getItem(KEY) === '1';
    } catch (e) {
      return false;
    }
  };

  const TEASER_KEY = 'd2-popup-teaser-v1';
  const teaser = document.getElementById('d2-teaser');
  const teaserRetired = () => {
    try {
      return localStorage.getItem(TEASER_KEY) === 'off';
    } catch (e) {
      return false;
    }
  };
  const retireTeaser = () => {
    try {
      localStorage.setItem(TEASER_KEY, 'off');
    } catch (e) {}
    if (teaser) teaser.hidden = true;
  };
  const showTeaser = () => {
    if (teaser && !teaserRetired()) teaser.hidden = false;
  };

  const isSuccess = !!dialog.querySelector('[data-popup-success]');
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  /* Desktop scrolls .page-wrapper, phones scroll the document (established
     store fact) — read whichever is actually moving. */
  const scroller = () => document.querySelector('.page-wrapper');
  const scrollTop = () => {
    const el = scroller();
    return Math.max(window.scrollY || 0, el ? el.scrollTop : 0);
  };
  const getScrollThreshold = () => {
    const percent = parseInt(
      isMobile() ? dialog.dataset.mobileScrollPercent : dialog.dataset.desktopScrollPercent,
      10
    );
    return window.innerHeight * ((Number.isFinite(percent) ? percent : 60) / 100);
  };

  const anotherDialogOpen = () => !!document.querySelector('dialog[open]:not(#d2-popup)');
  const open = () => {
    if (dialog.open) return true;
    if (anotherDialogOpen()) return false;
    try {
      dialog.showModal();
      return true;
    } catch (e) {
      return false;
    }
  };

  dialog.querySelector('.d2-popup__close')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', markDone);

  if (teaser && !(window.Shopify && Shopify.designMode)) {
    if (isSuccess) retireTeaser();
    dialog.addEventListener('close', () => {
      if (!isSuccess) showTeaser();
    });
    teaser.querySelector('.d2-teaser__open')?.addEventListener('click', () => {
      if (open()) teaser.hidden = true;
    });
    teaser.querySelector('.d2-teaser__x')?.addEventListener('click', retireTeaser);
    /* parked on the first screen, where it would cover the rating and price,
       and (2026-09-28) once the footer reaches the screen: the footer carries
       the same signup, and with the phone buy bar now sinking at the footer
       the tab dropped into the corner onto the payment icons (4 of 9 covered
       at 390 in the cold check) */
    const footer = document.querySelector('.d2-footer');
    const parkTeaser = () => {
      const atFoot = !!footer && footer.getBoundingClientRect().top < window.innerHeight;
      teaser.classList.toggle('is-parked', scrollTop() < window.innerHeight * 0.9 || atFoot);
    };
    document.addEventListener('scroll', parkTeaser, { passive: true, capture: true });
    parkTeaser();
    if (!isSuccess && alreadySeen()) showTeaser();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:select', (e) => {
      if (e.target.contains(dialog)) open();
    });
    document.addEventListener('shopify:section:deselect', (e) => {
      if (e.target.contains(dialog)) dialog.close();
    });
  } else if (isSuccess) {
    open();
  } else if (!alreadySeen()) {
    let armed = false;
    const cleanup = () => {
      document.removeEventListener('scroll', handleScroll, true);
      window.removeEventListener('mouseout', handleExitIntent);
    };
    const tryOpen = () => {
      if (!armed || alreadySeen()) return;
      if (open()) cleanup();
    };
    const handleScroll = () => {
      if (scrollTop() >= getScrollThreshold()) tryOpen();
    };
    const handleExitIntent = (event) => {
      if (dialog.dataset.desktopExitIntent === 'true' && !isMobile() && event.clientY <= 0) {
        tryOpen();
      }
    };

    /* capture phase so scrolls inside .page-wrapper are seen too */
    document.addEventListener('scroll', handleScroll, { passive: true, capture: true });
    window.addEventListener('mouseout', handleExitIntent);
    setTimeout(() => {
      armed = true;
      handleScroll();
    }, (parseInt(dialog.dataset.delay, 10) || 6) * 1000);
  }
})();
